import {action, computed, makeObservable, observable, runInAction} from "mobx";
import CommonStore from "../../stores/CommonStore";
import MoneyExchangeRate from "../../entities/productOrder/moneyDelivery/MoneyExchangeRate";
import { MoneyExchangeService } from "../../service/moneyDelivery/MoneyExchangeRateService";

class MoneyExchangeStore {

    public moneyExchanges: MoneyExchangeRate[];
    public filter?: string;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore) {
        this.moneyExchanges = [];
        this.commonStore = commonStore;
        makeObservable(this, {
            moneyExchanges: observable,
            isEmpty: computed
        });
    }

    get isEmpty(): boolean {
        return this.moneyExchanges.length === 0;
    }

    get canCreate(): boolean {
        return this.moneyExchanges.length >= 3;
    }

    public setFilter(filer: string) {
        this.filter = filer;
    }

    @action
    public async search() {
        await this.getElements();
    }

    @action
    public async getElements(): Promise<void> {
        this.commonStore.setLoading();
        const response = await MoneyExchangeService.get(1, 1000, this.filter);
        if (response.success) {
            runInAction(() => {
                this.moneyExchanges = response.data?.data || [];
            })
        }
        this.commonStore.processErrors(response);
        this.commonStore.removeLoading();
    }

}

export default MoneyExchangeStore;